import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "msg-toast-box" }
const _hoisted_2 = { class: "text" }

import {ref} from "vue";
import { CheckMobileDevice } from "@/utils/handle";


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
  msgText: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(CheckMobileDevice)() ? 'msg-toast-m' : 'msg-toast')
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.msgText), 1)
    ], 2)
  ]))
}
}

})